import { SectionLabel } from '../ui/SectionLabel';
import { site } from '../../data/site';

export function Contact() {
  return (
    <section className="section section-alt" id="contact" aria-labelledby="contact-title">
      <div className="wrap contact-inner">
        <div className="contact-copy" data-reveal>
          <SectionLabel>Contact</SectionLabel>
          <h2 id="contact-title">Let’s discuss your engineering problem.</h2>
          <p className="contact-intro">
            Tell us where you are in the lifecycle — early analysis, detailed design,
            implementation, integration or verification — and where specialist support
            would make the greatest difference.
          </p>

          <dl className="contact-details">
            <div className="contact-row">
              <dt>Email</dt>
              <dd>
                <a href={`mailto:${site.email}`}>{site.email}</a>
              </dd>
            </div>
            <div className="contact-row">
              <dt>Phone</dt>
              <dd>
                <a href={`tel:${site.phoneHref}`}>{site.phone}</a>
              </dd>
            </div>
            <div className="contact-row">
              <dt>Location</dt>
              <dd>{site.location}</dd>
            </div>
          </dl>
        </div>

        <form
          className="contact-form"
          name="engineering-enquiry"
          method="POST"
          action="/thanks/"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
          data-reveal
        >
          <input type="hidden" name="form-name" value="engineering-enquiry" />
          <p className="sr-only">
            <label>
              Do not fill in this field
              <input name="bot-field" tabIndex={-1} autoComplete="off" />
            </label>
          </p>

          <div className="contact-form-grid">
            <div className="contact-field">
              <label htmlFor="enquiry-name">Name</label>
              <input id="enquiry-name" name="name" type="text" autoComplete="name" required />
            </div>
            <div className="contact-field">
              <label htmlFor="enquiry-organisation">Organisation</label>
              <input
                id="enquiry-organisation"
                name="organisation"
                type="text"
                autoComplete="organization"
              />
            </div>
          </div>

          <div className="contact-field">
            <label htmlFor="enquiry-email">Work email</label>
            <input
              id="enquiry-email"
              name="email"
              type="email"
              autoComplete="email"
              inputMode="email"
              required
            />
          </div>

          <div className="contact-field">
            <label htmlFor="enquiry-area">Area of interest</label>
            <select id="enquiry-area" name="area-of-interest" defaultValue="" required>
              <option value="" disabled>
                Select an area
              </option>
              <option>Control, autonomy and estimation</option>
              <option>Software and firmware</option>
              <option>Modelling, simulation and verification</option>
              <option>Systems architecture and integration</option>
              <option>Data and operational systems</option>
              <option>Other</option>
            </select>
          </div>

          <div className="contact-field">
            <label htmlFor="enquiry-description">Project or challenge</label>
            <textarea
              id="enquiry-description"
              name="project-description"
              rows={5}
              placeholder="A short description is enough to start."
              required
            />
          </div>

          <div className="contact-form-footer">
            <button className="btn btn-primary" type="submit">
              Send enquiry
            </button>
            <p>Your details will only be used to respond to this enquiry.</p>
          </div>
        </form>
      </div>
    </section>
  );
}
